import React, { useState, useEffect } from 'react';
import './App.css';
import MainLayout from './components/MainLayout';
import LoginPage from './components/LoginPage';
import { Toaster } from './components/ui/toaster';
import { installAuthFetch } from './lib/authFetch';

// Install global Bearer-token injector for /api/* requests
installAuthFetch();

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isChecking, setIsChecking] = useState(true);
  const [environment, setEnvironment] = useState(null); // 'test' | 'production'

  const API_URL = process.env.REACT_APP_BACKEND_URL;

  // Check for existing token on mount
  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('auth_token');
      if (token) {
        try {
          const response = await fetch(`${API_URL}/api/auth/verify`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token })
          });
          const data = await response.json();
          if (data.valid) {
            setIsAuthenticated(true);
            setEnvironment(data.environment || 'test');
          } else {
            localStorage.removeItem('auth_token');
          }
        } catch (err) {
          console.error('Auth check failed:', err);
        }
      }
      setIsChecking(false);
    };

    checkAuth();
  }, [API_URL]);

  const handleLogin = (token, env) => {
    setIsAuthenticated(true);
    setEnvironment(env || 'test');
  };

  const handleLogout = async () => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      try {
        await fetch(`${API_URL}/api/auth/logout`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token })
        });
      } catch (err) {
        console.error('Logout error:', err);
      }
    }
    localStorage.removeItem('auth_token');
    setIsAuthenticated(false);
    setEnvironment(null);
  };

  // Show nothing while checking auth
  if (isChecking) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-amber-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="App">
      {isAuthenticated ? (
        <MainLayout onLogout={handleLogout} environment={environment} />
      ) : (
        <LoginPage onLogin={handleLogin} />
      )}
      <Toaster />
    </div>
  );
}

export default App;